import { AspectRatio, ComponentAlignment, CornerRadius, Video } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const VideoDemo = () => {
  const args = {
    videoUrl: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    posterUrl: 'https://i.ytimg.com/vi/aqz-KE-bpKQ/maxresdefault.jpg',
    aspectRatio: '16/9' as AspectRatio,
    hideControls: false,
    hideVolumeControl: false,
    cornerRadius: 'medium' as CornerRadius,
    width: 100,
    alignment: 'center' as ComponentAlignment,
    margin: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  }
  return (
    <LayoutDemo title='Video' bgColor='var(--color-primary-90)'>
      <Video id='video-example' {...args} backgroundColor={'primary-80'} />
    </LayoutDemo>
  )
}
